import { render, staticRenderFns } from "./OfferPerformance.vue?vue&type=template&id=2e106e36&"
import script from "./OfferPerformance.vue?vue&type=script&lang=ts&"
export * from "./OfferPerformance.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports